module.exports = __webpack_public_path__ + "static/img/cba7b4cdb2fc41d7f29fb45d94972e41.cba7b4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/item/cba7b4cdb2fc41d7f29fb45d94972e41.jpg
// module id = NQaC
// module chunks = 0